const ServiceProjectManage = () => import('@/pages/service-manage/ServiceProjectManage');
const ProjectOperate = () => import('@/pages/service-manage/ProjectOperate');
const CommissionRate = () => import('@/pages/service-manage/CommissionRate');


export default[
    {
      path: '/service-project-manage',
      component: ServiceProjectManage,
      meta: [
        {
          name: '服务管理',
          url: '',
        },
        {
          name: '服务项目管理',
          url: '',
        },
      ],
    },
    {
      path: '/service-project-manage/project-operate',
      component: ProjectOperate,
      meta: [
        {
          name: '服务管理',
          url: '/service-project-manage',
        },
        {
          name: '服务项目管理',
          url: '/service-project-manage',
        },
        {
          name: '服务项目新建',
          url: '',
        },
      ],
    },
    {
      path: '/commission-rate',
      component: CommissionRate,
      meta: [
        {
          name: '服务管理',
          url: '/service-project-manage',
        },
        {
          name: '佣金比例设置',
          url: '',
        },
      ],
    },
]
